import type { OrganizationBrandingResponse, UpdateOrganizationBrandingRequest } from '@/api/organization/organization.types';
import type { BrandingConfig, ThemeMode } from '@/types/ConfigOrg';
import { INITIAL_BRANDING_CONFIG } from '@/utils/ConfigOrg/constants';

function normalizeThemeMode(value?: string | null): ThemeMode {
  return value === 'dark' ? 'dark' : 'light';
}

export function mapBrandingResponseToState(response: OrganizationBrandingResponse): BrandingConfig {
  const organizationLogoUrl = response.organizationLogoUrl ?? null;

  if (!response.isConfigured) {
    return { ...INITIAL_BRANDING_CONFIG, organizationLogoUrl };
  }

  return {
    organizationLogoUrl,
    companyLogo: response.companyLogoUrl ?? null,
    favicon: response.faviconUrl ?? null,
    brandColor: response.brandColor ?? INITIAL_BRANDING_CONFIG.brandColor,
    fontColor: response.fontColor ?? INITIAL_BRANDING_CONFIG.fontColor,
    bodyFontColor: response.bodyFontColor ?? INITIAL_BRANDING_CONFIG.bodyFontColor,
    themeMode: normalizeThemeMode(response.themeMode),
  };
}

export function mapBrandingStateToRequest(config: BrandingConfig): UpdateOrganizationBrandingRequest {
  return {
    brandColor: config.brandColor,
    fontColor: config.fontColor,
    bodyFontColor: config.bodyFontColor,
    themeMode: config.themeMode,
    clearCompanyLogo: config.companyLogo === null,
    clearFavicon: config.favicon === null,
  };
}

export function mapBrandingStateToRequestWithoutClears(
  config: BrandingConfig,
): UpdateOrganizationBrandingRequest {
  return {
    brandColor: config.brandColor,
    fontColor: config.fontColor,
    bodyFontColor: config.bodyFontColor,
    themeMode: config.themeMode,
  };
}
